import getGlobal from '../getGlobal';
var g = getGlobal();
export default g.cancelAnimationFrame || g.webkitCancelAnimationFrame || g.mozCancelAnimationFrame || g.oCancelAnimationFrame || g.msCancelAnimationFrame || g.clearTimeout;


//////////////////
// WEBPACK FOOTER
// ./node_modules/dom-lib/es/animation/cancelAnimationFramePolyfill.js
// module id = 1301
// module chunks = 31